/* Pillowcase upsell in the cart (snippets/sr-cart-upsell.liquid): – / + picker,
   add with /cart/add.js, a short confirmation, then the cart is re-rendered
   without a reload (the upsell is gone because the pillowcase is in the cart).
   The desktop side panel lives outside the drawer's own re-render area, so it
   is refreshed after every other cart change too. */
(() => {
  if (window.srCartUpsellBound) return;
  window.srCartUpsellBound = true;

  const MIN = 1;
  const MAX = 10;
  const all = () => document.querySelectorAll('[data-sr-upsell]');

  const show = (root) => {
    const qty = Number(root.dataset.qty) || MIN;
    const totals = (root.dataset.totals || '').split('|');
    root.querySelector('[data-sr-upsell-count]').textContent = String(qty);
    const total = root.querySelector('[data-sr-upsell-total]');
    if (total && totals[qty - 1]) total.textContent = totals[qty - 1];
    root.querySelector('[data-sr-upsell-minus]').disabled = qty <= MIN;
    root.querySelector('[data-sr-upsell-plus]').disabled = qty >= MAX;
  };

  const sectionsFor = (root) => {
    const drawer = root.closest('cart-drawer') || (root.id === 'SrUpsellPanel' ? document.querySelector('cart-drawer') : null);
    if (drawer && drawer.getSectionsToRender) return { drawer, ids: drawer.getSectionsToRender().map((s) => s.id) };
    const cartItems = document.querySelector('cart-items');
    if (cartItems && cartItems.getSectionsToRender) return { cartItems, ids: cartItems.getSectionsToRender().map((s) => s.section) };
    return { ids: [] };
  };

  const renderCartPage = (cartItems, state) => {
    cartItems.getSectionsToRender().forEach((section) => {
      const host = document.getElementById(section.id);
      const html = state.sections && state.sections[section.section];
      if (!host || !html) return;
      const target = host.querySelector(section.selector) || host;
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      if (source) target.innerHTML = source.innerHTML;
    });
  };

  const add = async (root, button) => {
    const error = root.querySelector('[data-sr-upsell-error]');
    const target = sectionsFor(root);
    button.disabled = true;
    if (error) error.hidden = true;
    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(root.dataset.variant), quantity: Number(root.dataset.qty) || MIN }],
          sections: target.ids,
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || '');
      all().forEach((r) => {
        r.querySelector('[data-sr-upsell-card]').hidden = true;
        r.querySelector('[data-sr-upsell-done]').hidden = false;
        r.classList.add('is-done');
      });
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      setTimeout(() => {
        if (target.drawer) target.drawer.renderContents(state);
        else if (target.cartItems) renderCartPage(target.cartItems, state);
        else window.location.reload();
      }, reduce ? 900 : 1300);
    } catch (e) {
      if (error) {
        error.textContent = e.message || 'Er ging iets mis. Probeer het opnieuw.';
        error.hidden = false;
      }
      button.disabled = false;
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sr-upsell-minus], [data-sr-upsell-plus], [data-sr-upsell-add]');
    if (!button) return;
    const root = button.closest('[data-sr-upsell]');
    if (!root) return;
    if (button.matches('[data-sr-upsell-add]')) {
      add(root, button);
      return;
    }
    const step = button.matches('[data-sr-upsell-plus]') ? 1 : -1;
    const qty = Math.min(MAX, Math.max(MIN, (Number(root.dataset.qty) || MIN) + step));
    all().forEach((r) => {
      r.dataset.qty = String(qty);
      show(r);
    });
  });

  // Desktop side panel: refresh after quantity changes or removals in the drawer
  const refreshPanel = async () => {
    const panel = document.getElementById('SrUpsellPanel');
    const drawerBox = document.getElementById('CartDrawer');
    if (!drawerBox) return;
    try {
      const html = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`).then((r) => r.text());
      const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('SrUpsellPanel');
      if (panel && fresh) panel.replaceWith(fresh);
      else if (panel) panel.remove();
      else if (fresh) drawerBox.insertBefore(fresh, drawerBox.querySelector('.drawer__inner'));
    } catch (e) {
      /* the panel simply stays as it was */
    }
  };
  // Dawn's subscribe() and PUB_SUB_EVENTS are globals, but not on window
  // eslint-disable-next-line no-undef
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    // eslint-disable-next-line no-undef
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === 'product-form') return; // the drawer re-renders itself then
      refreshPanel();
    });
  }
})();
